import { CaretLeft } from '@phosphor-icons/react'
import { Button } from 'antd'
import React from 'react'
import { classesEventStore } from 'state/classes/classesStore'
import ButtonSpinner from 'components/global/ButtonSpinner'
import FeeModal from './Modals/FeeModal'
import Calculation from './EssentialComps/Calculation'
import { useCostAndFeeForClasses } from 'api/Classes/ClassesCostAndFee/CostAndFee'


interface CostsProps {
  handleNext: (data?: any) => void
  handleBack: () => void
}

const Costs: React.FC<CostsProps> = ({ handleNext, handleBack }) => {
  const { feeModal, classesData, setClassesData, step3Payload } =
    classesEventStore(store => ({
      feeModal: store.feeModal,
      classesData: store.classesData,
      setClassesData: store.setClassesData,
      step3Payload: store.step3Payload,
    }))

  const { mutate: costAndFeeMutation, isLoading: costAndFeeMutationLoading } =
    useCostAndFeeForClasses()

  const handleSubmit = () => {
    costAndFeeMutation(
      {
        classId: classesData._id,
        payload: step3Payload,
      },
      {
        onSuccess: updatedData => {
          setClassesData({ ...classesData, ...updatedData })
          handleNext()
        },
      },
    )
  }

  return (
    <div className="step3-main-container">
      <div className="content scroller overflow-auto-y">
        <h3 className="text-24 w-600"> Step 5. Costs and Fees</h3>
        <p className="mt-20px">
          Based on your class details we recommend the number of staff
        </p>

        <div className="mt-15px">
          <Calculation />
        </div>
      </div>
      
      <div className="mt-15px event-button-cont">
        <h5
          className="flex gap-10px align-center pointer"
          onClick={() => handleBack()}
        >
          <CaretLeft size={20} color="#000" />
          <span className="text-15 w-500">Back</span>
        </h5>
        <Button className="stepper-button" onClick={handleSubmit}>
          {costAndFeeMutationLoading ? (
            <ButtonSpinner size={20} color="#000" />
          ) : (
            'Next'
          )}
        </Button>
      </div>

      {feeModal && <FeeModal />}
    </div>
  )
}

export default Costs
